import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Force light theme by setting data-theme attribute
document.documentElement.setAttribute('data-theme', 'light');
document.documentElement.classList.remove('dark');
document.documentElement.style.colorScheme = 'light';

// Load Cloudflare Web Analytics only in production when enabled and on allowed hostnames
(() => {
  try {
    const enabled = String(process.env.REACT_APP_ENABLE_ANALYTICS) === 'true';
    if (!enabled) return;

    const defaultHosts = ['threatcompass.eu', 'www.threatcompass.eu'];
    const allowed = (process.env.REACT_APP_ANALYTICS_ALLOWED_HOSTNAMES || defaultHosts.join(','))
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);

    if (!allowed.includes(window.location.hostname)) return;

    const token = process.env.REACT_APP_CF_BEACON_TOKEN || '666b4b6471414d0f8082c22dc0351c77';
    if (!token) return;

    const script = document.createElement('script');
    script.src = 'https://static.cloudflareinsights.com/beacon.min.js';
    script.defer = true;
    script.setAttribute('data-cf-beacon', JSON.stringify({ token }));
    document.body.appendChild(script);
  } catch {
    // no-op: analytics should never break the app
  }
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Optional Service Worker for caching (enable via REACT_APP_ENABLE_SW=true)
(() => {
  try {
    const enableSw = String(process.env.REACT_APP_ENABLE_SW) === 'true';
    if (!enableSw || !('serviceWorker' in navigator)) return;
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => undefined);
    });
  } catch {
    // ignore
  }
})();
